export default "__VITE_ASSET__b15dc9fb__"